window.PermissionsAPI = new function () {
    var self = this;
    var _protected = BaseAPI.call(self);

    _protected.setApiUrl(publicConfiguration.getBaseAPI("PermissionsServer"));

    self.getUserBrandPolicy = function (brandsList) {
        var defer = $q.defer();
        var params = {};

        params['brands_ids'] = brandsList;

        _protected.request('policy', 'GET', params)
            .then(function (res) {

                if (res && res.data && res.data.data) {
                    var brands = res.data.data.brands;

                    var receivedBrandIds = _.pluck(brands, 'brandId');

                    for (var i in brandsList) {
                        if (receivedBrandIds.indexOf(parseInt(brandsList[i])) === -1) {
                            res.data.data.brands.push({
                                brandId: parseInt(brandsList[i]),
                                permissions: [],
                            });
                        }
                    }

                    defer.resolve(res.data.data);
                }
                else {
                    defer.reject(res);
                }
            })
            .catch(function (err) {
                console.error(err);
                defer.reject(err);
            });

        return defer.promise;
    };

    self.getAllUserAccessBrands = function (brandId, userId) {

        var deferred = $q.defer();
        var params = {};


        _protected.request('brands/' + brandId + '/users/' + userId + '/access' , 'GET', params)
            .then(function (res) {
                if (res && res.data && res.data.data) {

                    deferred.resolve(res.data.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.checkUserTypeIfExists = function (brandId, email) {
        var deferred = $q.defer();

        var requestPayload = {};
        requestPayload.email = email;

        _protected.request('brands/' + brandId + '/users/status', 'GET', requestPayload).then(function (res) {
            if (res && res.data) {
                deferred.resolve(res.data.data);
            } else {
                deferred.reject(res.data.data);
            }

        }, function (err) {
            deferred.reject(err);
        });

        return deferred.promise;
    };

    self.deleteUserFromPermission = function (brandId, userId) {
        var deferred = $q.defer();

        _protected.request('brands/' + brandId + '/users/' + userId, 'DELETE')
            .then(function (res) {

                if (res && res.data) {
                    deferred.resolve(res.data);
                } else {
                    deferred.reject(res);
                }

            }, function (err) {
                deferred.reject(err);
            });

        return deferred.promise;
    };

    self.getBrandUsersByPermission = async (brandIds, permissions, requireAllPermissions = true) => {

        let params = {};
        params.brands_ids = brandIds.join(',');
        params.permissions = permissions;
        //require_all_permissions is false = OR, require_all_permissions is ture (default) = AND .
        params.require_all_permissions = requireAllPermissions;

        const result = await _protected.request(self.apiUrl.replace('v1', 'v2') + 'permissions/users', 'GET', params);
        if (result.data?.data && result.status === 200) {
            return result.data.data;
        }
        throw result;
    };
};